import * as angular from 'angular';
import {ApplicationPropertyRS} from '../admin/service/applicationPropertyRS.rest';
import {SerfPropertyRS} from '../admin/service/serfPropertyRS.rest';
import {SerfWebAuthentication} from '../authentication/authentication.module';
import router from '../dvbModules/router/router.module';
import DVBernUtil from '../utils/DVBernUtil';
import {DvAccordionComponentConfig} from './component/dv-accordion/dv-accordion';
import {DvAccordionTabComponentConfig} from './component/dv-accordion/dv-accordion-tab/dv-accordion-tab';
import {AdresseComponentConfig} from './component/dv-adresse/dv-adresse';
import {DvAlertBoxComponentConfig} from './component/dv-alert-box/dv-alert-box';
import {DVAnlaufstelleListComponentConfig} from './component/dv-anlaufstelle-list/dv-anlaufstelle-list';
import {AuszahlungComponentConfig} from './component/dv-auszahlung/dv-auszahlung';
import {DvBarChartsComponentConfig} from './component/dv-bar-charts/dv-bar-charts';
import {DVBemerkungErfassenComponentConfig} from './component/dv-bemerkung-erfassen/dv-bemerkung-erfassen';
import {DVBemerkungListComponentConfig} from './component/dv-bemerkung-list/dv-bemerkung-list';
import {DVBenutzerListComponentConfig} from './component/dv-benutzer-list/dv-benutzer-list';
import {DVBenutzerprofilComponentConfig} from './component/dv-benutzerprofil/dv-benutzerprofil';
import {BetragComponentConfig} from './component/dv-betrag/dv-betrag';
import {DvBisherComponentConfig} from './component/dv-bisher/dv-bisher';
import {DVChecklistComponentConfig} from './component/dv-checklist/dv-checklist';
import {DVDokumentuploadComponentConfig} from './component/dv-dokumentupload/dv-dokumentupload';
import {DVEigenleistungenListComponentConfig} from './component/dv-eigenleistungen-list/dv-eigenleistungen-list';
import {DvErrorMessagesComponentConfig} from './component/dv-error-messages/dv-error-messages';
import {DVFremdkostenListComponentConfig} from './component/dv-fremdkosten-list/dv-fremdkosten-list';
import {GenossenschaftComponentConfig} from './component/dv-genossenschaft/dv-genossenschaft';
import {GeoAdminMapComponentConfig} from './component/dv-geoadmin-map/dv-geoadmin-map';
import {GeoAdminSearchComponentConfig} from './component/dv-geoadmin-search/dv-geoadmin-search';
import {DvGesuchNavigationComponentConfig} from './component/dv-gesuch-navigation/dv-gesuch-navigation';
import {GesuchstellerComponentConfig} from './component/dv-gesuchsteller/dv-gesuchsteller';
import {DvHomeIconComponentConfig} from './component/dv-home-icon/dv-home-icon';
import {IbanInputComponentConfig} from './component/dv-iban-input/dv-iban-input';
import {DvInputContainerComponentConfig} from './component/dv-input-container/dv-input-container';
import {DVInspektoratListComponentConfig} from './component/dv-inspektorat-list/dv-inspektorat-list';
import {KoerperschaftComponentConfig} from './component/dv-koerperschaft/dv-koerperschaft';
import {KontaktPersonComponentConfig} from './component/dv-kontakt-person/dv-kontakt-person';
import {DVLanguageSelectComponentConfig} from './component/dv-languageselect/dv-languageselect';
import {LeistungsempfaengerComponentConfig} from './component/dv-leistungsempfaenger/dv-leistungsempfaenger';
import {MapComponentConfig} from './component/dv-map/dv-map';
import {DVPasswordChangerComponentConfig} from './component/dv-password-changer/dv-password-changer';
import {DvPieChartsComponentConfig} from './component/dv-pie-charts/dv-pie-charts';
import {DVSchadenListComponentConfig} from './component/dv-schaden-list/dv-schaden-list';
import {SchadenComponentConfig} from './component/dv-schaden/dv-schaden';
import {DVSchadenfaelleListConfig} from './component/dv-schadenfaelle-list/dv-schadenfaelle-list';
import {DVStatusChangeHistoryComponentConfig} from './component/dv-status-change-history-list/dv-status-change-history-list';
import {StringInputComponentConfig} from './component/dv-string-input/dv-string-input';
import {DvTextValueComponentConfig} from './component/dv-text-value/dv-text-value';
import {DvTooltipComponentConfig} from './component/dv-tooltip/dv-tooltip';
import {DVAnlaufstelleTypeaheadComponentConfig} from './component/dv-typeahead/dv-anlaufstelle-typeahead/dv-anlaufstelle-typeahead';
import {DVBenutzerTypeaheadComponentConfig} from './component/dv-typeahead/dv-benutzer-typeahead/dv-benutzer-typeahead';
import {DVGemeindeTypeaheadComponentConfig} from './component/dv-typeahead/dv-gemeinde-typeahead/dv-gemeinde-typeahead';
import {DvVersicherungNavigationComponentConfig} from './component/dv-versicherung-navigation/dv-versicherung-navigation';
import {DVVersicherungsbeitragListConfig} from './component/dv-versicherungsbeitrag-list/dv-versicherungsbeitrag-list';
import {DVVersionComponentConfig} from './component/dv-version/dv-version';
import {DVVorleistungenListComponentConfig} from './component/dv-vorleistungen-list/dv-vorleistungen-list';
import {DVZahlungenListConfig} from './component/dv-zahlungen-list/dv-zahlungen-list';
import {DVZahlungsauftragListConfig} from './component/dv-zahlungsauftrag-list/dv-zahlungsauftrag-list';
import {configure} from './config';
import './core.module.scss';
import {appRun} from './core.route';
import {DvDateRange} from './directive/dv-date-range/dv-date-range';
import {DVDatepicker} from './directive/dv-datepicker/dv-datepicker';
import {DvDialog} from './directive/dv-dialog/dv-dialog';
import {DVLoadingButton} from './directive/dv-loading-button/dv-loading-button';
import {DVHTTPLoading} from './directive/dv-loading-http/dv-http-loading';
import {DVLoading} from './directive/dv-loading/dv-loading';
import DVMaxLength from './directive/dv-max-length/dv-max-length';
import {DvPagination} from './directive/dv-pagination/dv-pagination';
import DvSchadenfaelleListPersist from './directive/dv-schadenfaelle-list-persist/dv-schadenfaelle-list-persist';
import DVScrollNav from './directive/dv-scroll-nav/dv-scroll-nav';
import {DVShowElement} from './directive/dv-show-element/dv-show-ement';
import {DVRoleElementController} from './directive/dv-show-element/DVRoleElementController';
import DVStTableRefresh from './directive/dv-st-table-refresh/dv-st-table-refresh';
import {DVValueinput} from './directive/dv-valueinput/dv-valueinput';
import {DVBernErrors} from './errors/errors';
import HttpResponseInterceptor from './errors/service/HttpResponseInterceptor';
import AnlaufstelleRS from './service/AnlaufstelleRS.rest';
import BatchJobRS from './service/batchRS.rest';
import BegruendungscodeMapperService from './service/BegruendungscodeMapperService';
import BeitragRS from './service/BeitragRS';
import BemerkungRS from './service/bemerkungRS.rest';
import BenutzerRS from './service/BenutzerRS.rest';
import BerechtigungsService from './service/BerechtigungsService';
import CockpitRS from './service/cockpitRS.rest';
import DokumenteRS from './service/dokumenteRS.rest';
import {DownloadRS} from './service/downloadRS.rest';
import EigenleistungenRS from './service/EigenleistungenRS';
import FilterPersistenceService from './service/FilterPersistenceService';
import FondssuisseRS from './service/FondssuisseRS.rest';
import FremdkostenRS from './service/FremdkostenRS';
import GemeindeRS from './service/GemeindeRS.rest';
import HttpVersionInterceptor from './service/HttpVersionInterceptor';
import InspektoratRS from './service/InspektoratRS.rest';
import IsNeuInStatusService from './service/isNeuInStatusService';
import {NavigationLogger} from './service/NavigationLogger';
import OverdueService from './service/OverdueService';
import {PageNameConstants} from './service/PageNameConstants';
import PasswordStrengthService from './service/PasswordStrengthService';
import PiwikService from './service/PiwikService';
import {ReportAsyncRS} from './service/reportAsyncRS.rest';
import RoleUtilService from './service/RoleUtilService';
import SchadenfallModelManager from './service/SchadenfallModelManager';
import SchadenfallRS from './service/schadenfallRS.rest';
import SchadenRS from './service/schadenRS.rest';
import StatuswechselService from './service/StatuswechselService';
import {UploadRS} from './service/uploadRS.rest';
import VereinbarungAkzeptiertService from './service/VereinbarungAkzeptiertService';
import VersicherungRS from './service/versicherungRS.rest';
import VersicherungsbeitragModelManager from './service/VersicherungsbeitragModelManager';
import VersicherungsbeitragRS from './service/versicherungsbeitragRS.rest';
import VorleistungRS from './service/VorleistungenRS';
import ZahlungsauftragRS from './service/ZahlungsauftragRS.rest';
import {MenubarComponentConfig} from './toolbar/menubar';

declare let ENV: any;

let dynamicDependencies = function (): string[] {

    let dynDep: string [] = [];
    //hier kommen plugins die wir fuer dev disablen wollen
    if (ENV === 'production') {
        return ['ngRaven'];
    }
    if (ENV === 'test') {
        return [];
    }
    return dynDep;
};

const dependencies: string[] = [
    /* Angular modules */
    'ngAnimate',
    'ngSanitize',
    'ngMessages',
    'ngAria',
    'ngCookies',
    /* shared DVBern modules */
    router.name,
    DVBernErrors.name,
    SerfWebAuthentication.name,
    /* 3rd-party modules */
    'ui.bootstrap',
    'smart-table',
    'ngMessages',
    'pascalprecht.translate',
    'angularMoment',
    'vcRecaptcha',
    'ngSanitize',
    'ui.select',
    'ngFileUpload',
    'ngMap',
    'ngMapAutocomplete',
    'unsavedChanges',
];

export const SerfWebCore: angular.IModule = angular
    .module('serfWeb.core', dependencies.concat(dynamicDependencies()))
    .run(appRun)
    .config(configure)

    .constant('REST_API', '/serf/api/v1/')
    .constant('MAX_LENGTH', 255)
    .constant('CONSTANTS', {
        name: 'SERF',
        REST_API: '/serf/api/v1/',
        MAX_LENGTH: 255,
        PATTERN_BETRAG: '([0-9]{0,12})',
        PATTERN_PERCENTAGE: '^[0-9][0-9]?$|^100$',
        PATTERN_PHONE: '(0|\\+41|0041)\\s?([\\d]{2})\\s?([\\d]{3})\\s?([\\d]{2})\\s?([\\d]{2})',
        PATTERN_PHONE_OPTIONAL: '(^$|^(0|\\+41|0041)\\s?([\\d]{2})\\s?([\\d]{3})\\s?([\\d]{2})\\s?([\\d]{2})$)',
        PATTERN_MOBILE: '(0|\\+41|0041)\\s?(74|75|76|77|78|79)\\s?([\\d]{3})\\s?([\\d]{2})\\s?([\\d]{2})',
        PATTERN_EMAIL: '[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}',
    })
    .constant('PAGE_NAMES', new PageNameConstants())
    .directive('dvLoading', DVLoading.factory())
    .directive('dvHttpLoading', DVHTTPLoading.factory())
    .directive('dvLoadingButton', DVLoadingButton.factory())
    .directive('dvMaxLength', DVMaxLength.factory())
    .directive('dvScrollNav', DVScrollNav.factory())
    .directive('dvStTableRefresh', DVStTableRefresh.factory())
    .directive('dvDatepicker', DVDatepicker.factory())
    .directive('dvShowElement', DVShowElement.factory())
    .directive('dvValueinput', DVValueinput.factory())
    .directive('dvDateRange', DvDateRange.factory())
    .directive('dvPagination', DvPagination.factory())
    .directive('dvSchadenfaelleListPersist', DvSchadenfaelleListPersist.factory())

    .component('dvBenutzerList', new DVBenutzerListComponentConfig())
    .component('dvAnlaufstelleList', new DVAnlaufstelleListComponentConfig())
    .component('dvInspektoratList', new DVInspektoratListComponentConfig)
    .component('dvEigenleistungenList', new DVEigenleistungenListComponentConfig())
    .component('dvSchadenList', new DVSchadenListComponentConfig())
    .component('dvBemerkungList', new DVBemerkungListComponentConfig())
    .component('dvStatusChangeHistoryList', new DVStatusChangeHistoryComponentConfig())
    .component('dvBemerkungErfassen', new DVBemerkungErfassenComponentConfig())
    .component('dvChecklist', new DVChecklistComponentConfig())
    .component('dvFremdkostenList', new DVFremdkostenListComponentConfig())
    .component('dvVorleistungenList', new DVVorleistungenListComponentConfig())
    .component('dvBenutzerprofil', new DVBenutzerprofilComponentConfig())
    .component('dvErrorMessages', new DvErrorMessagesComponentConfig())
    .component('dvAlertBox', new DvAlertBoxComponentConfig())
    .component('dvGesuchNavigation', new DvGesuchNavigationComponentConfig())
    .component('dvVersicherungNavigation', new DvVersicherungNavigationComponentConfig())
    .component('dvPasswordChanger', new DVPasswordChangerComponentConfig())
    .component('dvTooltip', new DvTooltipComponentConfig())
    .component('dvHomeIcon', new DvHomeIconComponentConfig())
    .component('dvSchadenfaelleList', new DVSchadenfaelleListConfig())
    .component('dvZahlungenList', new DVZahlungenListConfig())
    .component('dvZahlungsauftragList', new DVZahlungsauftragListConfig())
    .component('dvInputContainer', new DvInputContainerComponentConfig())
    .component('menubar', new MenubarComponentConfig)
    .component('dvLanguageselect', new DVLanguageSelectComponentConfig)
    .component('dvAdresse', new AdresseComponentConfig())
    .component('dvLeistungsempfaenger', new LeistungsempfaengerComponentConfig())
    .component('dvBetrag', new BetragComponentConfig())
    .component('dvAuszahlung', new AuszahlungComponentConfig())
    .component('dvStringInput', new StringInputComponentConfig())
    .component('dvIbanInput', new IbanInputComponentConfig())
    .component('dvKontaktPerson', new KontaktPersonComponentConfig())
    .component('dvGenossenschaft', new GenossenschaftComponentConfig())
    .component('dvGesuchsteller', new GesuchstellerComponentConfig)
    .component('dvKoerperschaft', new KoerperschaftComponentConfig())
    .component('dvSchaden', new SchadenComponentConfig())
    .component('dvMap', new MapComponentConfig())
    .component('dvGeoadminMap', new GeoAdminMapComponentConfig())
    .component('dvGeoadminSearch', new GeoAdminSearchComponentConfig())
    .component('dvPieCharts', new DvPieChartsComponentConfig())
    .component('dvBarCharts', new DvBarChartsComponentConfig())
    .component('dvTextValue', new DvTextValueComponentConfig())
    .component('dvAnlaufstelleTypeahead', new DVAnlaufstelleTypeaheadComponentConfig())
    .component('dvGemeindeTypeahead', new DVGemeindeTypeaheadComponentConfig())
    .component('dvBenutzerTypeahead', new DVBenutzerTypeaheadComponentConfig())
    .component('dvDokumentupload', new DVDokumentuploadComponentConfig())
    .component('dvAccordion', new DvAccordionComponentConfig())
    .component('dvAccordionTab', new DvAccordionTabComponentConfig())
    .component('dvBisher', new DvBisherComponentConfig())
    .component('dvVersion', new DVVersionComponentConfig())
    .component('dvVersicherungsbeitragList', new DVVersicherungsbeitragListConfig())
    .controller('DVElementController', DVRoleElementController)
    .service('ApplicationPropertyRS', ApplicationPropertyRS)
    .service('SerfPropertyRS', SerfPropertyRS)
    .service('SchadenfallModelManager', SchadenfallModelManager)
    .service('VersicherungsbeitragModelManager', VersicherungsbeitragModelManager)
    .service('DVBernUtil', DVBernUtil)
    .service('PasswordStrengthService', PasswordStrengthService)
    .service('FilterPersistenceService', FilterPersistenceService)
    .service('BegruendungscodeMapperService', BegruendungscodeMapperService)
    .service('VereinbarungAkzeptiertService', VereinbarungAkzeptiertService)
    .service('RoleUtilService', RoleUtilService)
    .service('PiwikService', PiwikService)
    .service('StatuswechselService', StatuswechselService)
    .service('BerechtigungsService', BerechtigungsService)
    .service('OverdueService', OverdueService)
    .service('IsNeuInStatusService', IsNeuInStatusService)
    .service('BenutzerRS', BenutzerRS)
    .service('AnlaufstelleRS', AnlaufstelleRS)
    .service('InspektoratRS', InspektoratRS)
    .service('FondssuisseRS', FondssuisseRS)
    .service('GemeindeRS', GemeindeRS)
    .service('DvDialog', DvDialog)
    .service('HttpResponseInterceptor', HttpResponseInterceptor)
    .service('HttpVersionInterceptor', HttpVersionInterceptor)
    .service('SchadenfallRS', SchadenfallRS)
    .service('VersicherungsbeitragRS', VersicherungsbeitragRS)
    .service('VersicherungRS', VersicherungRS)
    .service('UploadRS', UploadRS)
    .service('FremdkostenRS', FremdkostenRS)
    .service('EigenleistungenRS', EigenleistungenRS)
    .service('NavigationLogger', NavigationLogger)
    .service('VorleistungenRS', VorleistungRS)
    .service('BeitragRS', BeitragRS)
    .service('ZahlungsauftragRS', ZahlungsauftragRS)
    .service('DokumenteRS', DokumenteRS)
    .service('DownloadRS', DownloadRS)
    .service('SchadenRS', SchadenRS)
    .service('BemerkungRS', BemerkungRS)
    .service('ReportAsyncRS', ReportAsyncRS)
    .service('BatchJobRS', BatchJobRS)
    .service('CockpitRS', CockpitRS)
    .filter('arrayToString', () => {
        return function (input: Array<string>) {
            return input.join(', ');
        };
    });



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts